import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {StartupService} from "../../service-ui/startup.service";
import {NavbarService} from "../../service-ui/navbar.service";
import {EditorProjectService} from "../../service-data/editor/editor-project.service";
import {FormBuilder} from '@angular/forms';
import { MatSidenav } from "@angular/material/sidenav";
import {MediaMatcher} from "@angular/cdk/layout";
import {LoggedInCallback} from "../../service-auth/cognito.service";
import {Subject} from "rxjs";

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnDestroy, OnInit, LoggedInCallback {
  @ViewChild('mainSideNav', { static: true }) mainSideNav: MatSidenav;
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  onDestroySubject: Subject<boolean> = new Subject();

  // ── Filter & display state (owned here, passed as @Input to cart-page) ──
  searchString: string = '';
  showDetails: boolean = true;
  showCoverImage: boolean = true;
  showOnlyRecent: boolean = false;
  showNonZero: boolean = true;
  showProducts: boolean = true;
  showDrafts: boolean = true;
  showTable: boolean = true;

  // ── Mode (CART vs CHECKOUT) — single source of truth lives on the Cart ──
  get mode(): string {
    const cart = this.startupService.getCart();
    return cart ? cart.cartStage : 'CART';
  }
  set mode(value: string) {
    const cart = this.startupService.getCart();
    if (cart) { cart.cartStage = value as any; }
  }

  /**
   * True when the toolbar Checkout button should be disabled. Blocks
   * on ANY of:
   *  - cart isn't ready (no items yet)
   *  - no item has a positive quantity (nothing to check out)
   *  - some non-zero item is still waiting on its production-rate
   *    fetch (`PENDING`) or has no feasible price at the chosen
   *    quantity (`INFEASIBLE`) or has a totally-empty rate table
   *    (`ERROR`). Delegates to `Cart.allNonZeroItemsPriced()` which
   *    encapsulates the per-item pricing-state check.
   *
   * The cart-page component surfaces the corresponding hint in the
   * summary bar so the user can see WHY the button is disabled
   * ("Fix the highlighted items…" for pricing failures, "Waiting for
   * prices…" for a pending fetch).
   */
  get checkoutDisabled(): boolean {
    const cart = this.startupService.getCart();
    if (!cart || !cart.items) { return true; }
    if (!cart.items.some(item => item.quantity > 0)) { return true; }
    if (typeof cart.allNonZeroItemsPriced === 'function' && !cart.allNonZeroItemsPriced()) { return true; }
    return false;
  }

  proceedToCheckout() {
    if (!this.checkoutDisabled) {
      const cart = this.startupService.getCart();
      cart.setNonZeroItems();
      cart.cartStage = 'CHECKOUT';
    }
  }

  backToCart() {
    const cart = this.startupService.getCart();
    if (cart) { cart.cartStage = 'CART'; }
  }

  constructor(public router: Router, public startupService: StartupService, private navbarService: NavbarService, private projectService: EditorProjectService, private formBuilder: FormBuilder, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher) {
    this.startupService.touchLastUserActivity();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }


  ngOnInit() {
    this.startupService.isAuthenticated(this);
  }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (!isLoggedIn) {
      this.router.navigate(['/home/login']);
    } else {
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.onDestroySubject.next(true);
    this.onDestroySubject.unsubscribe();
  }
}

